import styled from "styled-components";

export const Container = styled.div`
    text-align: left;
    margin: auto;
    position: absolute;
    margin-top: 0;
  padding: 20px;
  border-radius: 10px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
  background: white;
  font-family: Arial, sans-serif;
  .details {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 20px;

}
`;

export const Title = styled.h3`
  margin-bottom: 15px;
  font-size: 16px;
`;

export const RadioGroup = styled.div`
  margin-bottom: 15px;
`;

export const RadioLabel = styled.label`
  display: flex;
  align-items: center;
  margin-bottom: 8px;
`;

export const Input = styled.input`
  margin-right: 10px;
`;

export const Select = styled.select`
  width: 100%;
  padding: 8px;
  margin-top: 5px;
  border: 1px solid #ccc;
  border-radius: 4px;
`;

export const DateInput = styled.input`
  width: 100%;
  padding: 8px;
  margin-top: 5px;
  border: 1px solid #ccc;
  border-radius: 4px;
`;

export const TextInput = styled.input`
  width: 100%;
  padding: 8px;
  margin-top: 5px;
  border: 1px solid #ccc !important;
  border-radius: 4px;
`;

export const ButtonGroup = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: 20px;
`;

export const Button1 = styled.button`
background-color: #F6931E;
  width: 104px;
  padding: 8px 15px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  margin-left: 10px;
`;